module.exports = __webpack_public_path__ + "img/timetable.b9989a79.png";